export default {
  admin: {
    invoice: {
      title: "Billing — Accounting codification",
      tab: {
        payers: "Third-party payers",
        sequence: "Accounting document sequence",
        article_codes: "Article codes",
        terms_of_payment: "Terms of payment",
        bank_details: "Bank details",
      },
      alert: {
        locked: "Setting locked by the platform administrator",
        payer:
          "These values are inherited by each company when it is created. They remain individually editable on the company record.",
        article_code:
          "The code is locked and cannot be edited. All other fields are customisable — click the pencil to edit a row.",
        payment_code:
          "These reference tables feed the accounting entries transmitted to Sage. Codes defined by the STUDEA team — not editable.",
        bank_details:
          "Confidential information — transmitted to the Convergence API and displayed on accounting documents.",
        sequence_info: "Several payer types cannot share the same sequence. Enable the relevant types on each block.",
      },
      sequence: {
        add: "Add a sequence",
        add_success: "Sequence added successfully!",
        add__confirm: "Are you sure you want to add a sequence?",
        update_success: "Data updated successfully!",
        stats: {
          invoices: "Issued invoices",
          credits: "Issued credit notes",
          anomalies: "Sequence anomalies",
        },
      },
      payers: {
        actions: {
          apply_collective_account: {
            title: "Apply the collective account",
            subtitle: "To private companies without a defined account",
            subtitle_public: "To public companies without a defined account",
          },
          payment_terms: {
            title: "Apply payment terms",
            subtitle: "To private companies without defined terms",
            subtitle_public: "To public companies without defined terms",
          },
          missing_subsidiary_ledgers: {
            title: "Generate missing subsidiary ledgers",
            subtitle: "Existing numbers will not be overwritten",
          },
        },
        update: {
          success: "Data updated successfully!",
        },
        apply: {
          success: "{count} company/companies updated",
          opco: {
            success: "{count} OPCO(s) updated",
          },
        },
      },
      article_code: {
        edit: {
          success: "Article code updated successfully!",
        },
      },
      action: {
        deactivate: "Deactivate",
        activate: "Activate",
      },
      payment_code: {
        activated: {
          success: ({ plural }) => plural(["Code deactivated successfully!", "Code activated successfully!"]),
        },
        toggle_error: "Error updating the displayed data, please refresh the page",
      },
      bank_details: {
        success: "Bank details updated successfully!",
      },
    },
    help_settings: "Help settings",
    help_settings_success: "Help settings edited successfully!",
    lastEmail: "Link to last e-mail sent",
    generatePassword: "Regenerate and send password",
    switchUser: "Log in as {name}",
    switchAdmin: "You are logged in as",
    switchAdminLabel: "Admin",
    switchPilot: "Booklet manager",
    show: "Voir {title}",
    modify: "Edit {title}",
    delete: "Delete {title}",
    add: "Add",
    name: "Surname",
    title: "Title",
    year: "Year",
    trainingOpeningStart: "Start of course opening",
    trainingOpeningEnd: "End of course opening",
    level: "Level",
    registrationDate: "Registration date",
    active: "Active",
    management_of: "Management of",
    contents: "content",
    users: "Users",
    trainings: "Courses",
    archiving: {
      title: "Archiving",
      action: "To archive",
      archive_confirmation: "Are you sure you want to archive these promotions?",
      unarchive_confirmation: "Are you sure you want to unarchive these promotions?",
      archive_success: "Promotions archived successfully!",
      active_confirmation: "Are you sure you want to unarchive these promotions?",
      active_success: "Promotions unarchived successfully!",
      unarchive_success: "Promotions unarchived successfully!",
    },
    current_training_course_year: {
      title: "Modify the current year",
      error: "The reference year must be different from the new current year.",
      confirmation: {
        title: "Are you sure you want to change the current year?",
        subtitle: "It will be updated for all promotions whose start year matches the reference year.",
      },
      success: ({ named }) => `Current year changed for ${named("count")} promotions`,
    },
    livretConfig: {
      title: "Booklet activation",
      confirmation: "Confirm data modification?",
      success: "Booklet configuration saved successfully!",
    },
    modules: "Modules",
    module: "Module",
    code: "Code",
    error: "Error. Please try again later!",
    lastName: "Surname",
    firstName: "First name",
    profile: "Profile",
    embody: "Log in as",
    visible: "Visible",
    popup: "Popup",
    visibleHomeLea: "Visible",
    endDate: "End date",
    startDate: "Start date",
    contractTypeColor: "Contract colour",
    none_duplicated_user: "No user to merge",
    skill: {
      title: "Skill",
    },
    skillCategory: {
      title: "Category",
    },
    skill_session: {
      generate: "Generate periods",
      empty: "Please enter the number of periods to be created in the module configuration before applying changes",
      generation_success: "Periods generated successfully",
      existing_session: "You are about to delete existing periods. Are you sure you want to continue?",
    },
    skillReferential: {
      title: "Skills reference documentation",
      edit: "Edit reference documentation",
    },
    skill_import_france_competence: {
      title: "Importer tous les référentiels France Compétences",
      confirm: "Êtes-vous sûr de vouloir charger tous les référentiels France Compétences ?",
      success: "Référentiels importés avec succès !",
    },
    navigation: {
      users: "Users",
      trainings: "Courses",
      modules: "Modules",
      settings: "Settings",
      general: "General",
      steering: "Steering",
    },
    home: {
      title: "General configuration",
      title2: "Overview",
      title3: "Automatic sync",
      title4: "General statistics",
      active: "Activated",
      unique_connection: "unique connection",
      apprentices_mentor: "Apprentices and mentors",
    },
    log: {
      title: ({ plural }) => plural(["Log", "Logs"]),
      view: "See modified data",
      modify_field: "Field modified",
      old_data: "Old data",
      data: "New data",
      impersonation_chain: "Impersonation chain",
      impersonator_type: {
        zama: "Zama administrator",
        studea: "Studea administrator",
        studea_admin: "Studea administrator",
        studea_manager: "Studea manager",
      },
    },
    ypareoReporting: {
      title: ({ plural }) => plural(["Ypareo Report", "Ypareo Reports"]),
      view: "See the report",
    },
    edusignReporting: {
      title: ({ plural }) => plural(["Edusign Report", "Edusign Reports"]),
      view: "See the report",
    },
    registrationAlert: {
      title: ({ plural }) => plural(["Alert", "Alerts"]),
    },
    ammonReporting: {
      title: ({ plural }) => plural(["Ammon Report", "Ammon Reports"]),
      view: "See the report",
    },
    ggeReporting: {
      title: ({ plural }) => plural(["GGE Report", "GGE Reports"]),
      view: "See the report",
    },
    ssoReporting: {
      title: ({ plural }) => plural(["SSO Report", "SSO Reports"]),
      view: "See the report",
    },
    ofalinkReporting: {
      name: "Ofa Link",
      title: ({ plural }) => plural(["Ofa Link Report", "Ofa Link Reports"]),
      view: "See the report",
    },
    report: {
      title: ({ plural }) => plural(["Report", "Reports"]),
      view: "See the report",
    },
    mail: {
      title: ({ plural }) => plural(["Mail", "Mails"]),
      view: "See mail content",
      recipient: "Recipient:",
      status: "Sending status:",
      sent_on: "Sent on:",
      open_on: "Opened on:",
      error_message: "Error message",
      no_error_message: "The server returned no message.",
    },
    registrationField: {
      title: ({ plural }) => plural(["Field", "Fields"]),
    },
    registrationBlock: {
      title: ({ plural }) => plural(["Block", "Blocks"]),
    },
    registrationTab: {
      title: ({ plural }) => plural(["Tab", "Tabs"]),
    },
    registrationStep: {
      title: ({ plural }) => plural(["Step", "Steps"]),
    },
    registrationDataVersion: {
      title: ({ plural }) => plural(["Version", "Versions"]),
      notEmpty: "Some sheets are already attached to this version.",
    },
    registrationDevice: {
      title: ({ plural }) => plural(["Device", "Devices"]),
    },
    registrationDataConfiguration: "Modify version settings",
    cerfaParam: {
      title: ({ plural }) => plural(["Cerfa settings", "Cerfa settings"]),
    },
    role: {
      title: ({ plural }) => plural(["Role", "Roles"]),
    },
    triad: {
      title: ({ plural }) => plural(["Three-party group", "Three-party groups"]),
      delete_all_triad: {
        title: "Supprimer tous les trinômes",
        confirmation: "Êtes-vous sûr de vouloir supprimer tous les trinômes de cette promotion ?",
        success: "Trinômes supprimés avec succès !",
      },
    },
    studeaUser: {
      title: ({ plural }) => plural(["User", "Users"]),
    },
    user: {
      title: ({ plural }) => plural(["User", "Users"]),
      actions: {
        keep_user: "Retain",
        delete_user: "Delete",
        unselect_user: "Deselect these users",
        reset_password: {
          success: "A password reset link has been sent to the user successfully!",
        },
      },
      add_profile: "Add a profile",
      warning_profile: "Profile deletion",
      warning_profile_text: "Are you sure you want to delete this profile?",
      last_connection: "Dernière connexion le : \n",
      search_user_by_name_or_mail: "Search for a user by name or by e-mail address",
      import_users: "Import users",
      profile_config: "Profile configuration",
      merge: "Merge users",
      duplicated_user_count: "duplicated users to be merged",
      merge_duplicated_user_confirmation: "Are you sure you want to merge these users?",
      merge_success: "Merge completed successfully",
      no_double_user: "No duplicate found",
      mail_address: "E-mail address",
      already_connected: "Already logged in to the booklet",
      yes: "Yes",
      no: "No",
      row: "Line",
      reference_user: "User reference",
      duplicated_user: "Duplicates",
      reset_choices: "Reset selection",
      options: "Options",
      account_creation: "Account creation",
      username: "Username",
      external_id: "External ID",
      birth_date: "Date of birth",
      send_credential_back_to_user: "Send log-in details to the relevant user",
      reference_user_is_not_duplicate: "The user reference is not a duplicate",
      keep: "Retain",
      delete: "Delete",
      export: "Export",
      send: "Save",
      profile_title: "User profile titles",
      users_profile_title_list: "List of user profile titles",
      modify_profile: "Edit title",
      modification_succes: "Profile edited successfully!",
      no_mail_title: "No link",
      no_mail: "This user has not yet received a password reset link!",
      profile_user_info:
        "Create different booklet supervisor profiles with specific rights that can subsequently be attached to users. Example: Attendance manager, teaching manager, etc.",
      role: {
        NONE: "No",
        ALL: "Yes",
        VIEW: "View",
        EDIT: "Change",
        DELETE: "Delete",
      },
      erase_studeaManager_profile:
        "Please note, you are about to delete the booklet profile(s) attached to your account.",
    },
    profile_label: {
      titleAbbreviation: "Abbreviation",
      titlePlural: "Title in the plural",
      titleWithArticle: "Title with article",
    },
    training: {
      title: ({ plural }) => plural(["Training", "Courses"]),
      ufa_add_test: "Create a test training course",
      genere_triad_test: "Generate test three-party groups",
      generate_triad_test_confirmation:
        "Are you sure you want to create test three-party groups for all training courses? ",
      genere_triad_test_success: "Test three-party groups created successfully!",
      genere_training_test_success: "Test training course created successfully!",
      import_triad: "Import profiles of the three-party group",
      confirmation_subtitle: "This deletion will also result in the deletion of the promotions linked to this course.",
    },
    registration: {
      title: ({ plural }) => plural(["Registration", "Registrations"]),
    },
    trainingCourse: {
      title: ({ plural }) => plural(["Promotion", "Promotions"]),
      duplicate_on_next_year: "Duplicate the year group for the following year",
      duplicate: "Duplicate the year group",
      delete: "Delete the year group",
    },
    studeaManager: {
      title: ({ plural }) => plural(["Digital Booklet supervisor", "Digital booklet supervisors"]),
    },
    variable: {
      title: ({ plural }) => plural(["Variable", "Variables"]),
    },
    modele: {
      title: ({ plural }) => plural(["Template", "Templates"]),
    },
    copy: {
      success: ({ named }) => `${named("name")} copied successfully!`,
      title: ({ named }) => `Copy this ${named("name")}`,
      sub_title: ({ named }) => `Are you sure you want to copy this ${named("name")}?`,
      error: ({ plural, named }) =>
        plural([`An error occurred while copying the ${named("name")}. Please try again later!`]),
    },
    design: {
      title: "Layout",
    },
    dataAgreement: {
      title: ({ plural }) => plural(["Data policy", "Data policy"]),
    },
    institution: {
      title: ({ plural }) => plural(["Establishment", "Institutions"]),
      list: {
        title: "Active institutions",
      },
      export: {
        booklets: "Export of the institution's booklets",
        answers: "responses to the previous year's questionnaires",
      },
    },
    document: {
      title: ({ plural }) => plural(["Public document", "Public documents"]),
    },
    documentCategory: {
      title: ({ plural }) => plural(["Document category", "Document categories"]),
    },
    helpDocument: {
      title: ({ plural }) => plural(["Online help", "Online help files"]),
    },
    component: {
      title: ({ plural }) => plural(["Component", "Components"]),
      export: {
        title: "responses to the previous year's questionnaires",
      },
    },
    degree: {
      title: ({ plural }) => plural(["Type of qualification", "Types of qualification"]),
    },
    contractType: {
      title: ({ plural }) => plural(["Type of contract", "Types of contract"]),
    },
    planContract: {
      title: ({ plural }) => plural(["Year of training", "Years of training"]),
      actions: {
        activate: {
          title: "Activate",
          success: "Year of training activated successfully!",
        },
        activate_recruitment: {
          title: "Activate for recruitment",
          success: "Activated for recruitment successfully!",
        },
      },
    },
    titleRncp: {
      title: ({ plural }) => plural(["RNCP title", "RNCP titles"]),
    },
    modulet: {
      title: ({ plural }) => plural(["Module", "Modules"]),
      list: {
        title: "Module management",
      },
      trainingCourse: {
        edit: {
          title: "Edit the training courses linked to the module",
          success: "Training courses linked to the module edited successfully!",
        },
        displayActive: "Only display the training courses linked to the module",
      },
      config: {
        title: "Module configuration",
      },
      skill_session: {
        title: "Generate periods",
      },
      registration: {
        title: "Registration dashboard",
      },
      skill_referential: {
        title: "Skills reference documentation",
        list: "Reference documentation",
        edit: "Edit reference documentation",
        config: "Configuration du module",
      },
    },
    template: {
      title: ({ plural }) => plural(["Template", "Templates"]),
      success: "Template edited successfully !",
      duplicate: "Duplicate a template",
      default_template: "Default template",
    },
    absenceReason: {
      title: ({ plural }) => plural(["Reason for absence", "Reasons for absence"]),
    },
    questionnaireConfig: {
      title: "Questionnaire module configuration",
      multiple_actions: "Questionnaire editing",
      action_to_do: "Actions to perform",
      warning:
        "This action will modify all questionnaires from the selected year with the selected title. Empty fields will remain unchanged",
      confirmation: "Confirm data modification?",
      success: "Questionnaires successfully updated!",
    },
    ypareoConfig: {
      title: "Ypareo module configuration",
      get_directories: "Retrieve the ypareo directories",
      reference_tables: {
        tab_title: "Reference tables",
        intro:
          "These tables are fetched once from Ypareo and stored in Studea, so that syncing a file no longer needs to query Ypareo on every submission.",
        refresh_button: "Refresh from Ypareo",
        refresh_success: "Table refreshed successfully",
        mapping_saved: "Mapping saved",
        last_refreshed_at: "Last refresh: {date}",
        never_refreshed: "Never refreshed",
        active_count: ({ plural, named }) => plural([`${named("count")} active row`, `${named("count")} active rows`]),
        show_inactive: "Show inactive rows",
        code_column: "Ypareo code (read-only)",
        label_column: "Ypareo label (read-only)",
        mapping_column: "Studea mapping",
        active_column: "Status",
        active_value: "Active",
        inactive_value: "Inactive",
        no_studea_values:
          "No Studea value currently available for this referential — the mapping cannot be entered yet.",
        read_only_notice:
          "This referential can be viewed and refreshed, but its Studea mapping is not entered row by row: it is done by combination (status, degree, year, repeating) on a dedicated screen.",
        no_rows: "No row for this referential yet. Trigger a refresh to populate it from Ypareo.",
        mapping_aria_label: "Studea mapping for {label}",
        table_caption: "Reference table {label}",
        types: {
          civility: "Title",
          nationality: "Nationality",
          birth_country: "Country of birth",
          school_origin: "Prior schooling",
          obtained_degree: "Obtained degree",
          employer_type: "Employer type",
          situation: "Situation",
        },
      },
      exclusion_refresh: {
        intro:
          "These lists are fetched once from Ypareo and stored in Studea, to feed the exclusion filters of the tab below.",
        refresh_button: "Refresh from Ypareo",
        refresh_success: "List refreshed successfully",
        last_refreshed_at: "Last refresh: {date}",
        never_refreshed: "Never refreshed",
        active_count: ({ plural, named }) => plural([`${named("count")} active row`, `${named("count")} active rows`]),
        types: {
          status: "Statuses",
          group: "Groups",
        },
      },
      exclusion_list: {
        add_button: "Add an exclusion",
        empty: "No exclusion saved",
        code_column: "Code",
        label_column: "Label",
        delete_button: "Delete {code}",
        delete_confirm_title: "Remove this exclusion?",
        delete_confirm_subtitle: "Code {code} will be removed from the list.",
        delete_success: "Exclusion removed successfully",
        modal_title: "Add an exclusion — {label}",
        add_button_inclusion: "Add an inclusion",
        modal_title_inclusion: "Add an inclusion — {label}",
        empty_inclusion: "No inclusion saved",
        delete_confirm_title_inclusion: "Remove this inclusion?",
        delete_confirm_subtitle_inclusion: "Code {code} will be removed from the list.",
        delete_success_inclusion: "Inclusion removed successfully",
        search_label: "Search in {label}",
        search_placeholder: "Type at least 3 characters",
        searching: "Searching...",
        no_result: "No result",
        results_found: ({ plural, named }) =>
          plural([`${named("count")} result found`, `${named("count")} results found`]),
        add_result: "Add {label}",
        add_success: "{label} added successfully",
        included_group_title: "Included group codes",
        previous_group_title: "Group codes to import despite belonging to the previous period",
        excluded_group_title: "Excluded group codes",
        excluded_apprentice_title: "Excluded apprentices",
        mode_help: "The mode change will only be applied on the next save.",
      },
      school_origin_mapping: {
        intro:
          "For each Yparéo code, add the file answers that match it: already an apprentice (Yes/No), one or more degrees prepared and one or more last classes attended. A combination can only match one code; without a mapping, the apprentice is sent without a school origin and the application is not sent to Yparéo.",
        add_button: "Add",
        remove_aria: "Remove mapping {mapping}",
        add_aria: "Add a mapping to Yparéo code {code}",
        already_apprentice_label: "Already an apprentice?",
        degrees_label: "Degrees",
        classes_label: "Classes",
        delete_confirm_title: "Remove this mapping?",
        create_success: "Mapping added",
        delete_success: "Mapping removed",
        ypareo_inactive_warning: "Deactivated in Yparéo — to be fixed",
      },
    },
    driverLicenceConfig: {
      title: "Configuration du module permis B",
    },
    studeaManagerProfile: {
      title: ({ plural }) => plural(["Booklet supervisor profile", "Booklet supervisor profiles"]),
      all_access: "Enable all permissions",
    },
    historic: {
      title: "History",
    },
    statistic: {
      title: "Statistics",
      general: "General",
      questionnaires: "Questionnaires",
      absence: "Absences",
      course: "Lesson follow-up",
      global_export: "Exporter les statistiques",
      updated_on: "updated on",
      indicators_generated: "Additional indicators being generated",
    },
    export: {
      title: "Exports",
      year: "Year groups",
      available_exports: "Available exports",
      signature_questionnaire_all: "Export the signatures from the questionnaires for all qualifications",
      absence_cumulate_by_diploma: "Export cumulative absences by qualification",
      absence_by_apprentice: "Export absences by apprentice",
      company_visits: "Export company visits",
      contract: "Export contracts",
      dashboard: "Export monitoring dashboard",
      summary_table: "Export summary table",
      questionnaire: "Export a questionnaire",
      questionnaire_code_count: "Export number of questionnaires by code",
      category_questionnaires: "Questionnaires",
      category_absences: "Absences",
      category_contracts: "Contracts",
      category_general: "General",
      category_reversibility: "Reversibility",
      year_filter_hint: "This filter only applies to exports marked with the calendar icon",
      year_filter_badge_tooltip: "This export takes into account the year selected above",
      reversibility: "Export portfolios, skills and absences",
      reversibility_hint:
        "Single archive organised by institution then by promotion: apprenticeship portfolios as PDF with their attachments, skill assessments as PDF, absences as Excel. A manifest details what was actually produced. Long-running process.",
      reversibility_confirm_title: "Start the reversibility export?",
      reversibility_confirm_text:
        "This action generates an archive of several gigabytes and can take several hours. Only start it when the customer is definitively leaving.",
      reversibility_error: "The reversibility export failed. Please try again later.",
    },
    duplicate: {
      title: "Duplicates",
    },
    archive: {
      title: "Archive",
    },
    news: {
      title: ({ plural }) => plural(["News", "News"]),
      news_list: "List of news",
      list: {
        title: "News",
        uploaded_date: "Uploaded on",
        see_more: "See more",
        see_all_news: "See all news",
        go_back_newslist: "Back to the list of news items",
      },
    },
    import: {
      modele: "File template download",
      triad_new_file:
        "Please note - a new template came online on 18/09/2023.\n" +
        "          Please download this updated version for use to populate your three-party groups.",
      triad_update:
        "Please note. Only the missing members of a three-party group will be updated. No existing user data (last name, first name or e-mail address) will be updated.",
      thanks: "Please do not edit and/or delete the template columns",
      contract_type_id: "ID types de contrat (colonne AM)",
    },
    text: "Text",
    dateToDisplay: "Post date",
    emailContent: "E-mail content",
    picture: "Image",
    subTitle: "Subtitle",
    tag: "Tag",
    video: "Video",
    activate_notification: "Activate notifications",
    activate_notification_success: "Update notification preference",
    tutorial: {
      title: ({ plural }) => plural(["Tutorial", "Tutorials"]),
      admin: "Admin",
      studea_manager: "Booklet manager",
      user: "User",
    },
    ammonConfig: {
      title: "Ypareo module configuration",
      synchronisation: "Synchronisation",
      confirmation: "Are you sure you want to start synchronising with Ammon?",
    },
    contractRuptureConfig: {
      title: "Declaration of contract termination by the apprentice or the company",
    },
    reporting: {
      list: ({ named }) => `Les des rapports ${named("name")}`,
    },
    cfa_config: {
      success: "CFA configuration edited successfully !",
    },
    last_report: "Last report",
    opco: {
      success_update: "OPCO successfully updated!",
      synchronisation_confirmation: "Are you sure you want to synchronise this OPCO?",
      synchronisation_confirmation_subtitle:
        "You are about to manually start the synchronisation of OPCO {opco}.<br /><br />An automatic synchronisation already runs every night between 00:00 and 03:00.<br /><br />️ In the event of repeated calls outside this time slot, the OPCO may suspend access to its API.<br /><br />Do you confirm you want to start the synchronisation?",
      success_synchronisation: "Synchronisation started!",
      api_key: {
        valid: "Valid CFaDock API key",
        invalid: "Invalid CFaDock API key",
      },
      error_synchronisation: "Invalid CFaDock API key",
      invoice: {
        details: "View billing details",
        modal: {
          title: "Billing details for {opco}",
        },
        success_update: "Billing address successfully updated!",
      },
      files: {
        title: "OPCO records (3 years)",
        subtitle: "All OPCOs combined",
      },
      sync_files: {
        title: "Synchronised records",
        subtitle: "match rate",
      },
      guide: {
        title: "Reading guide",
        baseline: "Understand the synchronisation indicators",
        sync_file: {
          title: "Synchronised record",
          description:
            "Studea has linked this record with its OPCO equivalent. The data (status, DECA, funding) is up to date.",
        },
        corresponding: {
          title: "Likely match",
          description:
            "Score 4/5: one criterion does not match. The record is not linked automatically; manual confirmation is required.",
        },
        progression: {
          title: "Progress bar",
          description:
            "Synchronised records / total OPCO records. Shown in orange if one or more records are awaiting confirmation.",
        },
        sync_report: {
          title: "Synchronisation report",
          description: "XLSX export: detail of the matching criteria (SIRET, RNCP, dates, names) for each record.",
        },
        manual_sync: {
          title: "Manual synchronisation",
          description:
            "Reserved for tests and exceptional cases. Automatic synchronisation runs every night between 00:00 and 03:00.",
        },
        inactive: {
          title: "Inactive OPCO",
          description: "Connection not configured. Contact your Studea representative to activate it.",
        },
        matching_criteria: {
          title: "Matching criteria (score /5)",
          description:
            "Apprentice's date of birth · Apprentice's name · Company SIRET · Contract start date · RNCP code.<br><strong>5/5</strong> → automatic synchronisation  {'|'}  <strong>4/5</strong> → likely match (manual confirmation)  {'|'}  <strong>< 4/5</strong> → no match.",
        },
      },
    },
    activateOption: "Enable/Disable",
    ia_competences: {
      config_confirmation: "Are you sure you want to apply this AI-Competences configuration to the selected cohorts?",
      config_success: "AI-Competences configuration applied successfully!",
      reload_error: "An error occurred while reloading the data.",
      tab_formations: "Courses",
      tab_promotions: "Cohorts",
      help_text: "Select the courses or cohorts on the left, choose the AI settings to apply, then click Apply.",
      apply: "Apply",
      apply_sticky_aria: "Apply the AI settings to the selection",
      apply_footer_aria: "Apply the AI settings to the selection",
      features_title: "AI Features",
      module1_title: "RNCP Reference Framework",
      module1_label: "Module 1",
      module2_title: "Missions & Activities",
      module2_label: "Module 2",
      features_upcoming_title: "Upcoming Features",
      feature_enrichment: "Enrichment",
      feature_enrichment_desc: "Suggests complementary competences based on the imported RNCP title.",
      feature_program_breakdown: "Programme breakdown",
      feature_program_breakdown_desc: "Breaks down a programme into semesters, units and modules.",
      feature_matrix: "UE/Competences matrix",
      feature_matrix_desc: "Generates the UE/competences correspondence matrix for the reference framework.",
      feature_mission_breakdown: "Mission breakdown",
      feature_mission_breakdown_desc:
        "Transforms a mission into structured activities aligned with the reference framework.",
      feature_writing: "Writing assistant",
      feature_writing_desc: "Contextual suggestions to guide the apprentice through their activities.",
      feature_activity_skills: "Activity/Competences",
      feature_activity_skills_desc: "Identifies the RNCP competences mobilised and assesses the level achieved.",
      profile_rp: "AC",
      profile_admin: "Admin",
      profile_apprentice: "Apprentice",
      profile_tutor: "Mentor",
    },
  },
};
